import { InteractionRequiredAuthError, type AccountInfo, type PublicClientApplication } from '@azure/msal-browser'
import { getApiTokenRequest } from '@config/auth/msalConfig'
import { getTeamsSsoToken } from '@config/auth/teamsAuth'

export async function getPortalAccessToken(instance: PublicClientApplication, account?: AccountInfo) {
    const teamsToken = await getTeamsSsoToken()
    if (teamsToken) return teamsToken

    const selectedAccount = account ?? instance.getActiveAccount() ?? instance.getAllAccounts()[0]
    if (!selectedAccount) return null
    try {
        return (await instance.acquireTokenSilent({
            ...getApiTokenRequest(),
            account: selectedAccount,
        })).accessToken
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError) return null
        throw error
    }
}
